import React from 'react'

import Info from '../common/info'

type Props = {
  pendingTime?: string
}

export const ExpiryAlert = (props: Props) => {
  const { pendingTime } = props

  if (!pendingTime) {
    return null
  }

  return (
    <Info
      note={{
        position: 'top',
        type: 'error',
        icon: 'ClockOutlined',
        text: pendingTime,
      }}
    />
  )
}
